import { TryResult } from "../../cutil/LangUtil";
import { ErrorUtil } from "../../api/ErrorUtil";
import { RestInternalError, RestResponse } from "../../cutil/RestClient";
import { RunStreamResponseStreamResult } from "../../storyV2/function/FunctionBase";
import { StreamInternalError } from "../../cutil/StreamClient";
export class AdapterErrorUtil {
    static getErrorMsg(data) {
        let error = data;
        if (data instanceof TryResult) {
            error = data.error;
        }
        else if (data instanceof RunStreamResponseStreamResult) {
            error = data.error;
        }
        if (!error) {
            return AdapterErrorUtil.defaultErrorMessage;
        }
        let errorDescription = error.message;
        if (error instanceof RestResponse) {
            errorDescription = error.errorDescription;
        }
        if (error instanceof StreamInternalError) {
            errorDescription = error.errorDescription;
        }
        if (error instanceof RestInternalError) {
            errorDescription = error.errorDescription;
        }
        if (errorDescription === "Failed to fetch") {
            errorDescription = ErrorUtil.defaultErrorMsg;
        }
        if (errorDescription === "The user aborted a request.") {
            errorDescription = ErrorUtil.defaultErrorMsg;
        }
        return errorDescription || AdapterErrorUtil.defaultErrorMessage;
    }
}
AdapterErrorUtil.defaultErrorMessage = "Get content failed";
